import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { selectedFiltersCount, toggleProductFilter } = useFacet(facet)
    const [ active, setActive ] = useState(true)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={() => setActive(!active)}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-facet-name">{facet.name}</span>
                <Icon name="arrow" className="ns-absolute" />
            </span>
            <div class="ns-sidebar-submenu ns-d-none" id={`${facet.id}-sub-menu`}>
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {facet.data?.map(value => (
                        <li
                            key={value.value}
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="ns-count ns-d-inline-block ns-text-align-center">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
